import React from "react";
import {
  NavigationItem,
  compose,
  graphql,
  ChildProps
} from "@atlassiansox/microscopekit";
import { get } from "lodash";
import { withRouter, RouteComponentProps } from "react-router-dom";
import subCategoriesQuery from "./subcategories.query.graphql";
import { subCategories } from "./__generated__/subCategories";

const AkChildIssuesIcon = require("@atlaskit/icon/glyph/child-issues").default;
const { AkNavigationItemGroup } = require("@atlaskit/navigation");

type SubCategoriesViewProps = {
  id: string;
  subcategories?: subCategories;
};

type Props = ChildProps<SubCategoriesViewProps> &
  RouteComponentProps<{ id: string }>;

export const SubCategoriesView: React.FC<Props> = props => {
  const children = get(props, "subcategories.category.children", []);
  const {
    location: { pathname, search }
  } = props;
  const childrenCategories = children.map((c: any) => (
    <NavigationItem
      key={c.id}
      icon={<AkChildIssuesIcon />}
      text={c.displayName || c.name}
      href={
        pathname.replace(
          encodeURIComponent(props.id),
          encodeURIComponent(c.id)
        ) + (search ? search : "")
      }
    />
  ));

  return children.length !== 0 ? (
    <AkNavigationItemGroup key="Subcategories" title="Subcategories">
      {childrenCategories}
    </AkNavigationItemGroup>
  ) : null;
};

export const SubCategories: React.ComponentType<SubCategoriesViewProps> = compose(
  graphql(subCategoriesQuery, {
    name: "subcategories",
    skip: (props: Props) => !props.id,
    options: (props: Props) =>
      !props.id ? {} : { variables: { id: props.id } }
  }),
  withRouter
)(SubCategoriesView);
